// test1793
(1793 && 0);
